<template>
    <div v-if="version>26">
        <header class="my-header">
            <div @click="back()" class="head-back"></div>
            <h2>{{title}}</h2>
        </header>
        <div class="head-padd"></div>
    </div>
</template>
<script>

export default {
  data() {
    return {
      
    };
  },
  props:{
      title:{
        type:String,
        default:''
      },
      platform:{
          type:String,
          default:''
      },
      backType:{
          type:String,
          default:'h5'
      }
  },
  computed:{
    version(){
        if(this.platform){
            return parseInt(this.platform.replace('ios','').replace(/\./g,''))
        }else{
            return 1
        }
    }
  },
  methods: {
    back(){
        if(this.backType=='app'){
            window.webkit.messageHandlers.ClickHeaderBack.postMessage('backapp');
            return false
        }
        this.$router.back(-1)
    }
  },
};
</script>
<style scoped>
.my-header{
    width: 100%;
    height: 88px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.my-header h2{
    width: 73vw;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 24px;
    color: #333333;
    padding: 9px;
    text-align: center;
}
.head-back{
    width: 64px;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    background: url(/static/app/icon-mobile-back.png) no-repeat center center;
    background-size: 16px;
}
.head-padd{
    height: 88px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/MyHeader/MyHeader.vue